import { VehicleType } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";

import type { Assignation } from "./Assignation";
import type { SimpleOrderWithAssignationsAssignation } from "./SimpleOrderWithAssignationsAssignation";

@Exclude()
export class VehicleTypeAssignationPair {
    @Expose()
    public vehicleType: VehicleType;

    @Expose()
    public assignation: Assignation | SimpleOrderWithAssignationsAssignation | undefined;
}
